import { render, staticRenderFns } from "./FrameBox.vue?vue&type=template&id=2295bfd6&scoped=true&"
import script from "./FrameBox.vue?vue&type=script&lang=js&"
export * from "./FrameBox.vue?vue&type=script&lang=js&"
import style0 from "./FrameBox.vue?vue&type=style&index=0&id=2295bfd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2295bfd6",
  null
  
)

export default component.exports